import React, {useState, useEffect, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import './Login.css';
import swal from 'sweetalert';
import userIcon from '../../images/user-icon.png'
import axios from "axios";
import {Link} from "react-router-dom";
import LanguageSwitcher from "../../Components/languageswitcher/LanguageSwitcher";
import i18n from "i18next";

async function loginUser(credentials) {
    return axios.post(
        process.env.REACT_APP_API_ENDPOINT+'/app/login',
        credentials,
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': i18n.language,
            },
        }
    )
        .then(response => {
            return response;
        })
        .catch(err => {
            return err.response;
        });
}

export default function Login(){
    const { t } = useTranslation();
    let re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isEmail, setIsEmail] = useState(true)
    const [emailFocus, setEmailFocus] = useState(false)
    const [pFocus, setPFocus] = useState(false)
    const [error, setError] = useState("")

    const [attemptsLeft, setAttemptsLeft] = useState(null); // null yoki son
    const [blockedUntil, setBlockedUntil] = useState(null); // datetime string
    const [blockedSecondsLeft, setBlockedSecondsLeft] = useState(0);

    const intervalRef = useRef(null);

    const handlechange = (e) => {
        setEmail(e)
        setIsEmail(re.test(e))
    }
    const validateInput = (input) => {
        const forbiddenChars = /['"<>%;()&+]/;
        return forbiddenChars.test(input);
    };

    useEffect(() => {
        // intervalni boshlash agar blockedUntil bor bo'lsa
        if (blockedUntil) {
            if (intervalRef.current) clearInterval(intervalRef.current);
            const updateSeconds = () => {
                const diff = Math.max(0, Math.floor((new Date(blockedUntil).getTime() - Date.now()) / 1000));
                setBlockedSecondsLeft(diff);
                if (diff <= 0) {
                    // blok tugadi
                    setBlockedUntil(null);
                    setAttemptsLeft(null);
                    setBlockedSecondsLeft(0);
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                }
            };
            updateSeconds();
            intervalRef.current = setInterval(updateSeconds, 1000);
            return () => clearInterval(intervalRef.current);
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }
    }, [blockedUntil]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if(!isEmail) {
                setError(t('email_incorrect'))
                return false;
            }
            if(email.trim() !== '' && password.trim() !== '' && re.test(email)){
                setError('')
                if (validateInput(email) || validateInput(password)) {
                    setError(t("invalid_character"));
                } else {
                    setError("");
                    const response = await loginUser({
                        email,
                        password
                    });

                    // Agar server 429 yoki 401 tarzida xabar qaytargan bo'lsa, u orqali attempts/blocked ma'lumotini o'qiymiz
                    if (response && response.status) {
                        const data = response.data || {};
                        if (response.status === 200 && data.token) {
                            // muvaffaqiyatli
                            swal(t("success"), t("correct_username_pwd"), "success", {
                                buttons: false,
                                timer: 2000,
                            })
                                .then(() => {
                                    localStorage.setItem('reestr-token', data.token);
                                    localStorage.setItem('reestr-expiret', data.expiret_at);
                                    localStorage.setItem('reestr-role', data.role || '');
                                    window.location = '/company';
                                });
                            return;
                        } else {
                            // Xato holatlari
                            const attempts_remaining = data.attempts_remaining ?? null;
                            const blocked_until = data.blocked_until ?? null;

                            if (attempts_remaining !== null) {
                                setAttemptsLeft(attempts_remaining);
                            }
                            if (blocked_until) {
                                setBlockedUntil(blocked_until);
                            }

                            // Agar server xabarini ko'rsatish
                            const msg = data.message || data.error || t("login_failed");
                            swal(t("error"), msg, "error");
                        }
                    } else {
                        setError(t('login_failed'));
                    }
                }
            }else if(email.trim() === '' || password.trim() === ''){
                setError(t('email_or_pwd_not_entered'));
            }
        } catch (error){
            setError(`${t('login_failed')} ${error}`);
        }
    }

    const renderBlockedInfo = () => {
        if (blockedSecondsLeft > 0) {
            const minutes = Math.floor(blockedSecondsLeft / 60);
            const seconds = blockedSecondsLeft % 60;
            return (
                <div className="alert alert-danger mt-2">
                    {t('blocked_message_prefix')} {minutes}:{seconds.toString().padStart(2, '0')} {t('blocked_message_suffix')}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="container d-flex">
            <div className="site-login">
                <div className="title">
                    <img src={userIcon} alt="icon"/>
                    <h2>- {t('welcome')} -</h2>
                </div>
                <form onSubmit={handleSubmit} >
                    <div className="mb-3 field-loginform-email required">
                        <label className="form-label" htmlFor="loginform-email"><span className="text-danger">*</span>{t("email")}</label>
                        <input
                            id="loginform-email"
                            className={emailFocus && !email?"form-control is-invalid":"form-control"}
                            type="email"
                            name="username"
                            value={email || ""}
                            onChange={(e) => handlechange(e.target.value)}
                            onBlur={() => setEmailFocus(true)}
                            autoComplete="on"
                        />
                        <div className="hint">{!isEmail?t("email_err"):""}</div>
                        <div className="invalid-feedback">{t("email_required")}</div>
                    </div>
                    <div className="mb-3 field-loginform-password required">
                        <label className="form-label" htmlFor="loginform-password"><span className="text-danger">*</span>{t("pwd")}</label>
                        <input
                            id="loginform-password"
                            className={pFocus && !password?"form-control is-invalid":"form-control"}
                            type="password"
                            name="password"
                            value={password || ""}
                            onChange={(e) => setPassword(e.target.value)}
                            onBlur={()=>setPFocus(true)}
                            disabled={blockedSecondsLeft > 0}
                        />
                        <div className="invalid-feedback">{t("pwd_required")}</div>
                        <div className="text-danger">{error}</div>
                    </div>

                    {/* Attempts left indicator */}
                    {attemptsLeft !== null && attemptsLeft > 0 && (
                        <div className="mb-2 text-warning">
                            {t('attempts_left')}: {attemptsLeft}
                        </div>
                    )}

                    {/* Block info */}
                    {blockedSecondsLeft > 0 && renderBlockedInfo()}

                    <div className="form-group d-grid gap-2 mt-4">
                        <button type="submit" className="btn btn-primary d-block" name="login-button" disabled={blockedSecondsLeft > 0}>{t("login")}</button>
                    </div>
                </form>
                <div className="text-center p-2 mt-2">
                    <Link className="link1" to="/register">{t('sign_up')}</Link>
                </div>
                <br/>
                <LanguageSwitcher/>
            </div>
        </div>
    )
}
